const CM_TO_INCHES = 0.39370; // 0.39370" = 1cm
const GRAMS_TO_POUNDS = 0.002204623; // 0.002204623lb = 1g

const centimetersToInches = (centimeters, initialDenominator = 16, returnAsFloat = false) => {
	if (returnAsFloat !== false) return (parseFloat(centimeters) * CM_TO_INCHES).toFixed(returnAsFloat);
	const inches = (parseFloat(centimeters) * CM_TO_INCHES).toFixed(5);

	let wholeInches = Math.floor(inches);
	const remainder = parseInt(inches.toString().split('.')[1], 10);
	let denominator = initialDenominator;
	let numerator = Math.round(initialDenominator * (remainder * 0.00001));
	// reduce the fraction
	while (numerator && numerator % 2 === 0) {
		numerator /= 2;
		denominator /= 2;
	}

	if (numerator === 1 && denominator === 1) {
		wholeInches += 1;
		numerator = 0;
		denominator = initialDenominator;
	}

	return {
		wholeInches,
		numerator,
		denominator,
	};
};

const inchesToCentimeters = (inches, returnAsFloat = false) => {
	if (returnAsFloat !== false) return (parseInt(inches, 10) / CM_TO_INCHES).toFixed(returnAsFloat);
	return Math.round(parseInt(inches, 10) / CM_TO_INCHES);
};

const poundsToMetric = (pounds, gramThreshold = 500, returnMeasurementUnit = { g: 'g', kg: 'kg' }) => {
	const totalGrams = parseInt(pounds, 10) / GRAMS_TO_POUNDS;
	if (gramThreshold !== false && totalGrams >= gramThreshold) return `${(totalGrams / 1000).toFixed(2)}${returnMeasurementUnit.kg ? `${returnMeasurementUnit.kg}${totalGrams > 1000 ? 's' : ''}` : ''}`;
	return `${Math.round(totalGrams)}${returnMeasurementUnit ? returnMeasurementUnit.g : ''}`;
};

export { centimetersToInches, inchesToCentimeters, poundsToMetric };
